import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, unref as _unref, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 2 }
const _hoisted_2 = { key: 3 }

import { reactive, computed, ref, onMounted, toRaw } from 'vue'
import { useRoute } from 'vue-router'
import { Modal as AModal } from 'ant-design-vue'
import { message } from '@dc-platform/dc-components'
import ParamCodeCascader from '@/components/CosCascader/components/ParamCodeCascader.vue'
import ChannelText from '@/components/CosCascaderText/components/channel.vue'
import ClueMergeButton from '@/components/ClueMergeButton'
import CustomerAreaCascader from '@/components/CustomerAreaCascader/index.vue'
import CustomerAreaCascaderText from '@/components/CustomerAreaCascader/CustomerAreaCascaderText.vue'
import ClueAssign from '../components/ClueAssign.vue'
import { businessTypeEnum, customerUnfollowDayTypeEnum, customerTypeEnum } from '@/views/yuntuSales/commonEnum/dataConfig'
import { listByParamCodes } from '@/api/common'
import { customerListFormat } from '@/utils'
import { infoData } from '@/api/gucangSales/followRuleSetting'
import { publicClueList, publicClueCollect, salesClueDetail } from '@/api/yuntuSales/clueManage'
import type { ParamCodeItem } from '@/typings/common'
import type { LbuPublicClueParams, LbuPublicClueListItem } from '@/typings/api/clueManage'
import CustomerLabelCascader from '@/components/CustomerLabelCascader/index.vue'
import formatThousandSeparator from '@/utils/format'

const __default__ = { name: 'DcCosLbuPublicClue' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const route = useRoute()

const paramCodeData: {
  [key: string]: ParamCodeItem[]
} = reactive({
  lbu_follow_purpose: [], // 拜访目的
  lbu_follow_mode: [], // 拜访方式（跟进方式）
  lbu_customer_business_area: [], // 客户业务区域
  lbu_important: [], // 月潜在收入
  lbu_sales_category: [], // 销售品类
  lbu_cargo_type: [], // 货物类型
  lbu_logistics_service_provider: [], // 现有合作物流服务商
  lbu_shipping_channel: [], // 出货渠道
  lbu_daily_traffic: [] // 客户日均包裹数量
})
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_lbu',
    paramCodes: [
      'lbu_follow_purpose',
      'lbu_follow_mode',
      'lbu_customer_business_area',
      'lbu_important',
      'lbu_sales_category',
      'lbu_cargo_type',
      'lbu_logistics_service_provider',
      'lbu_shipping_channel',
      'lbu_daily_traffic'
    ]
  }).then((res) => {
    Object.assign(paramCodeData, res.data)
  })
}
const clueRuleList = ref<string[]>([])
const getFollowRuleInfo = async () => {
  const { data } = await infoData({ appId: 'cos_lbu', configType: 3 })
  clueRuleList.value = (data as any).CLUE_RULE_2.split(',')
}
onMounted(() => {
  getFollowRuleInfo()
  getByParamCodes()
})

const tableRef = ref()
const queryForm = reactive<LbuPublicClueParams>({ contact: { type: 1 }, timeSearch: { type: 1 } })

const columns = computed(() => [
  {
    title: '客户名称',
    dataIndex: 'customerName',
    cosType: 'link',
    path: '/lbu/salesClue/view',
    query: ['clueId', 'isPublicClue=1', `returnPath=${route.fullPath}`],
    fixed: 'left'
  },
  { title: '客户识别码', dataIndex: 'customerSerial' },
  { title: '客户标签', dataIndex: 'label' },
  {
    title: '业务类型',
    dataIndex: 'businessType',
    dicData: businessTypeEnum
  },
  { title: '线索ID', dataIndex: 'clueId' },
  { title: '来源渠道', dataIndex: 'channel' },
  { title: '前负责人', dataIndex: 'beforeFollowerName' },
  { title: '客户区域', dataIndex: 'customerRegion' },
  { title: '客户类型', dataIndex: 'customerType', dicData: customerTypeEnum },
  { title: '客户合同地址', dataIndex: 'customerAddress' },
  { title: '联系人姓名', dataIndex: ['contact', 'name'], cosType: 'mask' },
  { title: '手机号', dataIndex: ['contact', 'mobile'], cosType: 'mask' },
  { title: '邮箱', dataIndex: ['contact', 'email'], cosType: 'mask' },
  { title: '微信号', dataIndex: ['contact', 'wechat'], cosType: 'mask' },
  { title: 'QQ号', dataIndex: ['contact', 'qq'], cosType: 'mask' },
  { title: '固定电话', dataIndex: ['contact', 'tel'], cosType: 'mask' },
  { title: '备注', dataIndex: 'remark' },
  // { title: '业务地区', dataIndex: ['business', 'businessArea'], dicData: paramCodeData.lbu_customer_business_area },
  { title: '业务收入等级', dataIndex: ['business', 'monthIncome'], dicData: paramCodeData.lbu_important },
  { title: '年销售GMV(元)', dataIndex: ['business', 'annualSales'], type: 'money', sorter: true, width: 160 },
  // { title: '销售品类', dataIndex: ['business', 'salesCategory'], dicData: paramCodeData.lbu_sales_category },
  // { title: '货物类型', dataIndex: ['business', 'cargoType'], dicData: paramCodeData.lbu_cargo_type },
  // {
  //   title: '现有合作物流服务商',
  //   dataIndex: ['business', 'cooperativeLogistics'],
  //   dicData: paramCodeData.lbu_logistics_service_provider
  // },
  // { title: '出货渠道', dataIndex: ['business', 'deliveryChannel'], dicData: paramCodeData.lbu_shipping_channel },
  // { title: '客户日均包裹数量', dataIndex: ['business', 'dailyTraffic'], dicData: paramCodeData.lbu_daily_traffic },
  { title: '创建人', dataIndex: 'createByName' },
  { title: '创建时间', dataIndex: 'createTime', width: 190, sorter: true },
  { title: '首次领取时间', dataIndex: 'firstReceiveTime', width: 190, sorter: true },
  { title: '最后一次领取时间', dataIndex: 'lastReceiveTime', width: 190, sorter: true },
  { title: '流转公海池时间', dataIndex: 'transferTime', width: 190, sorter: true },
  { title: '操作', dataIndex: 'action', width: 200, fixed: 'right' }
])

const handledQueryParams = (params: LbuPublicClueParams) => {
  const queryForm = customerListFormat(params) // 处理客户名称和客户编码的批量查询参数
  const contacts = queryForm.contact?.keyword?.split(/[,，\s\n]/).filter((e: string) => e)
  if (contacts && contacts.length > 1) {
    queryForm.contact.keywordList = contacts
    delete queryForm.contact.keyword
  }
  return queryForm
}
const getList = (queryForm: LbuPublicClueParams, callBack: (res: any) => void) => {
  const params = handledQueryParams(queryForm) // 处理客户名称的批量查询参数

  const clueId = queryForm.clueId
  if (clueId !== undefined && clueId.length > 0) {
    params.clueIdList = clueId.split(' ')
    params.clueId = undefined
  }

  const customerSerial = queryForm.customerSerial
  if (customerSerial !== undefined && customerSerial.length > 0) {
    params.customerSerialList = customerSerial.split(' ')
    params.customerSerial = undefined
  }

  publicClueList(params).then((res) => {
    res.data.items.forEach((item: LbuPublicClueListItem) => {
      if (item.business?.monthIncome === 0) {
        item.business.monthIncome = undefined
      }
    })
    callBack(res)
  })
}
// 获取详情联系人信息
const showMask = (record: LbuPublicClueParams, callBack: (res: any) => void) => {
  salesClueDetail({ clueId: record.clueId as string }).then((res) => {
    const { contact } = res.data
    callBack(contact)
  })
}
const handleQueryChange = (type?: 'search' | 'fetch') => {
  if (type === 'search') {
    tableRef.value?.search()
  } else {
    tableRef.value?.fetch()
  }
}

const selectedData = ref<LbuPublicClueListItem[]>([])
const onSelectRowsChange = (selectedRowKeys: string[], selectedRows: LbuPublicClueListItem[]) => {
  selectedData.value = selectedRows
}

// 分配客户负责人
const clueAssignRef = ref()
const handleAssignPerson = (row?: LbuPublicClueListItem) => {
  if (!row && !selectedData.value?.length) return message.warning('请选择需要分配的线索')
  const data = row ? [row] : toRaw(selectedData.value)
  clueAssignRef.value?.init(data)
}
// 领取线索
const handleReceive = (row?: LbuPublicClueListItem) => {
  if (!row && !selectedData.value?.length) {
    return message.warning('请选择需要领取的线索')
  }
  const clueIdList: any[] = []
  if (row) {
    clueIdList.push(row.clueId)
  } else {
    selectedData.value.forEach((item) => {
      clueIdList.push(item.clueId)
    })
  }
  AModal.confirm({
    title: '是否确认领取所选择的线索？',
    content: `领取后${clueRuleList.value[0]}个工作日内未写${clueRuleList.value[1]}条跟进记录,线索会自动退回到公海池`,
    okText: '领取',
    onOk() {
      publicClueCollect({ clueIdList }).then(() => {
        message.success('领取成功')
        tableRef.value?.fetch()
      })
    },
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onCancel() {}
  })
}

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_input_group = _resolveComponent("a-input-group")!
  const _component_UserSelect = _resolveComponent("UserSelect")!
  const _component_CosRangePicker = _resolveComponent("CosRangePicker")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_ExportButton = _resolveComponent("ExportButton")!
  const _component_cos_table = _resolveComponent("cos-table")!
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_dc_layout_main, { "is-breadcrumb": true }, {
      default: _withCtx(() => [
        _createVNode(_component_dc_layout_content, null, {
          default: _withCtx(() => [
            _createVNode(_component_cos_table, {
              serial: "",
              rowKey: "clueId",
              "row-selection": { onChange: onSelectRowsChange },
              columns: columns.value,
              search: queryForm,
              "onUpdate:search": _cache[17] || (_cache[17] = ($event: any) => ((queryForm) = $event)),
              onMask: showMask,
              onFetch: getList,
              ref_key: "tableRef",
              ref: tableRef,
              tableId: "DcCosLbuPublicClue"
            }, {
              search: _withCtx(() => [
                _createVNode(_component_a_form, { model: queryForm }, {
                  default: _withCtx(() => [
                    _createVNode(_component_dc_form_item, { label: "线索ID" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: queryForm.clueId,
                          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((queryForm.clueId) = $event)),
                          maxlength: 200,
                          allowClear: "",
                          placeholder: "请输入"
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_dc_form_item, { label: "客户名称" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_textarea, {
                          value: queryForm.customerName,
                          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((queryForm.customerName) = $event)),
                          autoSize: { minRows: 1, maxRows: 4 },
                          placeholder: "请输入"
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_dc_form_item, { label: "联系方式" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input_group, { compact: "" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_select, {
                              value: queryForm.contact.type,
                              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((queryForm.contact.type) = $event)),
                              style: {"width":"33%"},
                              placeholder: "请选择"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_select_option, { value: 1 }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("手机号")
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_select_option, { value: 2 }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("固定电话")
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_select_option, { value: 3 }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("邮箱")
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_select_option, { value: 4 }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("微信号")
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_select_option, { value: 5 }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("qq")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["value"]),
                            _createVNode(_component_a_input, {
                              value: queryForm.contact.keyword,
                              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((queryForm.contact.keyword) = $event)),
                              maxlength: 100,
                              style: {"width":"67%"},
                              placeholder: "请输入"
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_dc_form_item, { label: "前负责人" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_UserSelect, {
                          value: queryForm.beforeFollowerList,
                          "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((queryForm.beforeFollowerList) = $event)),
                          placeholder: "请选择",
                          mode: "multiple",
                          allowClear: ""
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_dc_form_item, { label: "客户区域" }, {
                      default: _withCtx(() => [
                        _createVNode(CustomerAreaCascader, {
                          type: "search",
                          appId: "cos_lbu",
                          ids: queryForm.customerRegionList,
                          "onUpdate:ids": _cache[5] || (_cache[5] = ($event: any) => ((queryForm.customerRegionList) = $event))
                        }, null, 8, ["ids"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_dc_form_item, { label: "来源渠道" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input_group, { compact: "" }, {
                          default: _withCtx(() => [
                            _createVNode(ParamCodeCascader, {
                              type: "search",
                              ids: queryForm.channelList,
                              "onUpdate:ids": _cache[6] || (_cache[6] = ($event: any) => ((queryForm.channelList) = $event)),
                              appId: "cos_lbu",
                              paramCode: "lbu_source_channel",
                              style: {"width":"33%"}
                            }, null, 8, ["ids"]),
                            _createVNode(_component_a_input, {
                              value: queryForm.channelExplain,
                              "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((queryForm.channelExplain) = $event)),
                              maxlength: 100,
                              style: {"width":"67%"},
                              placeholder: "请输入",
                              allowClear: ""
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_dc_form_item, {
                      name: "timeType",
                      label: "时间筛选"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input_group, { compact: "" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_select, {
                              value: queryForm.timeSearch.type,
                              "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((queryForm.timeSearch.type) = $event)),
                              style: {"width":"33%"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_select_option, { value: 1 }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("创建时间")
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_select_option, { value: 2 }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("首次领取时间")
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_select_option, { value: 3 }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("最后一次领取时间")
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_select_option, { value: 4 }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("转为潜在时间")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["value"]),
                            _createVNode(_component_CosRangePicker, {
                              startTime: queryForm.timeSearch.startTime,
                              "onUpdate:startTime": _cache[9] || (_cache[9] = ($event: any) => ((queryForm.timeSearch.startTime) = $event)),
                              endTime: queryForm.timeSearch.endTime,
                              "onUpdate:endTime": _cache[10] || (_cache[10] = ($event: any) => ((queryForm.timeSearch.endTime) = $event)),
                              style: {"width":"67%"}
                            }, null, 8, ["startTime", "endTime"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_dc_form_item, { label: "客户识别码" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: queryForm.customerSerial,
                          "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((queryForm.customerSerial) = $event)),
                          allowClear: "",
                          placeholder: "请输入"
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_dc_form_item, { label: "客户标签" }, {
                      default: _withCtx(() => [
                        _createVNode(CustomerLabelCascader, {
                          type: "search",
                          onlyCommon: false,
                          appId: "cos_lbu",
                          ids: queryForm.labelIdList,
                          "onUpdate:ids": _cache[12] || (_cache[12] = ($event: any) => ((queryForm.labelIdList) = $event)),
                          allowClear: ""
                        }, null, 8, ["ids"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_dc_form_item, { label: "业务类型" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_select, {
                          value: queryForm.businessTypeList,
                          "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((queryForm.businessTypeList) = $event)),
                          options: _unref(businessTypeEnum),
                          placeholder: "请选择",
                          mode: "multiple",
                          allowClear: ""
                        }, null, 8, ["value", "options"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["model"])
              ]),
              button: _withCtx(() => [
                _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                  type: "primary",
                  onClick: _cache[14] || (_cache[14] = ($event: any) => (handleAssignPerson()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("分配线索")
                  ]),
                  _: 1
                })), [
                  [_directive_permission, 'lbu_public_clue_assign_btn']
                ]),
                _withDirectives((_openBlock(), _createBlock(_unref(ClueMergeButton), {
                  data: selectedData.value,
                  appId: "cos_lbu",
                  onSuccess: _cache[15] || (_cache[15] = ($event: any) => (handleQueryChange('fetch')))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("合并")
                  ]),
                  _: 1
                }, 8, ["data"])), [
                  [_directive_permission, 'lbu_public_clue_merge_btn']
                ]),
                _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                  onClick: _cache[16] || (_cache[16] = ($event: any) => (handleReceive()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("领取线索")
                  ]),
                  _: 1
                })), [
                  [_directive_permission, 'lbu_public_clue_receive_btn']
                ]),
                _withDirectives((_openBlock(), _createBlock(_component_ExportButton, {
                  appId: "cos_lbu",
                  taskType: "302",
                  search: handledQueryParams(queryForm)
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("导出")
                  ]),
                  _: 1
                }, 8, ["search"])), [
                  [_directive_permission, 'lbu_public_clue_export_btn']
                ])
              ]),
              bodyCell: _withCtx(({ column, record, text }) => [
                (column.dataIndex === 'channel')
                  ? (_openBlock(), _createBlock(ChannelText, {
                      key: 0,
                      appId: "cos_lbu",
                      paramCode: "lbu_source_channel",
                      value: text,
                      desc: record.channelExplain
                    }, null, 8, ["value", "desc"]))
                  : _createCommentVNode("", true),
                (column.dataIndex === 'customerRegion')
                  ? (_openBlock(), _createBlock(CustomerAreaCascaderText, {
                      key: 1,
                      appId: "cos_lbu",
                      value: text
                    }, null, 8, ["value"]))
                  : _createCommentVNode("", true),
                (column.dataIndex === 'label')
                  ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(record.label ? record.label.map((item) => item.labelName ).join('、') : '--'), 1))
                  : _createCommentVNode("", true),
                (column.type === 'money')
                  ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_unref(formatThousandSeparator)(text)), 1))
                  : _createCommentVNode("", true),
                (column.dataIndex === 'action')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                      _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                        type: "link",
                        onClick: ($event: any) => (handleAssignPerson(record))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("分配线索")
                        ]),
                        _: 2
                      }, 1032, ["onClick"])), [
                        [_directive_permission, 'lbu_public_clue_assign_btn']
                      ]),
                      _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                        type: "link",
                        onClick: ($event: any) => (handleReceive(record))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("领取线索")
                        ]),
                        _: 2
                      }, 1032, ["onClick"])), [
                        [_directive_permission, 'lbu_public_clue_receive_btn']
                      ])
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["row-selection", "columns", "search"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(ClueAssign, {
      ref_key: "clueAssignRef",
      ref: clueAssignRef,
      onFetch: _cache[18] || (_cache[18] = ($event: any) => (handleQueryChange('fetch')))
    }, null, 512)
  ], 64))
}
}

})